import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function sanitizeAvatarUrl(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (url.includes("ui-avatars.com")) return undefined;
  const projectId = import.meta.env.VITE_SUPABASE_PROJECT_ID;
  
  return url;
}
